import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { CashPipe } from '../../shared/pipes/cash.pipe';
var PromotionLeaderboardMyRankComponent = /** @class */ (function () {
    function PromotionLeaderboardMyRankComponent() {
        this.cashPipe = new CashPipe('en');
    }
    PromotionLeaderboardMyRankComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    PromotionLeaderboardMyRankComponent.prototype.wsopPrizeCustom = function (data) {
        var _this = this;
        var prize;
        var prizeITems = [];
        if (data.prizeItem) {
            data.prizeItem.map(function (item) {
                switch (item.currencyId) {
                    case 'GTD':
                        prizeITems.push(_this.cashPipe.transform(item.value, item.currencyId, 'symbol-narrow', '1.0-2'));
                        break;
                    default:
                        var description = JSON.parse(item.description);
                        prizeITems.push(description.name + " x " + item.quantity);
                        break;
                }
            });
            prize = "(" + prizeITems.join('+') + ")";
        }
        return prize;
    };
    return PromotionLeaderboardMyRankComponent;
}());
export { PromotionLeaderboardMyRankComponent };
